/**
 * The Daily Rates module's API paths.
 */

export const dailyRateEndpoints = {
  /** Query a month's worth of published rates. */
  rates: (params: {
    readonly propertyId: string;
    readonly ratePlanId: string;
    readonly roomTypeId: string;
    readonly from: string;
    readonly to: string;
  }): string =>
    `/v1/rates?propertyId=${encodeURIComponent(params.propertyId)}&ratePlanId=${encodeURIComponent(params.ratePlanId)}&roomTypeId=${encodeURIComponent(params.roomTypeId)}&from=${encodeURIComponent(params.from)}&to=${encodeURIComponent(params.to)}`,

  /** Publish/overwrite a range of nightly rates. */
  setRates: '/v1/rates',

  /** Taxes available for the property's currency. */
  taxes: (propertyId: string, currency: string): string =>
    `/v1/taxes?propertyId=${encodeURIComponent(propertyId)}&currency=${encodeURIComponent(currency)}`,
} as const;

export const ratePlanOptionsPath = (propertyId: string): string =>
  `/v1/rate-plans?propertyId=${encodeURIComponent(propertyId)}&pageSize=100&fields=id,name,code,currency`;

export const roomTypeOptionsPath = (propertyId: string): string =>
  `/v1/room-types?propertyId=${encodeURIComponent(propertyId)}&pageSize=100&fields=id,name,code`;
